/**
 * Do not edit directly
 */

export default "PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNiAxNiIgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ij48cGF0aCBkPSJNOC4yLDJMNy41LDEuM0wwLjgsOEw3LjUsMTQuN0w4LjIsMTRMMi4yLDhMOC4yLDJaIE0xNS4yLDJMMTQuNSwxLjNMNy44LDhMMTQuNSwxNC43TDE1LjIsMTRMOS4yLDhMMTUuMiwyWiIvPjwvc3ZnPg==";